import { useRouter } from 'next/router';
import React, { FC } from 'react';

import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import ErrorPage from '..';

type Component500Props = {
  errorMessage?: string;
};

const Component500: FC<Component500Props> = ({ errorMessage }) => {
  const theme = useTheme();
  const router = useRouter();
  const { t } = useTranslation();

  const handleClick = () => {
    router.push('/');
  };

  return (
    <ErrorPage
      title={
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { md: 48, xs: 36 },
            lineHeight: { md: '72px', xs: '43px' },
          }}
          textAlign="center"
          color={theme.palette.textV2.primary}
        >
          {t('error.500.title')}
        </Typography>
      }
      subtitle={errorMessage}
      errorCode={
        <Typography variant="subtitle1" textAlign="center" color={theme.palette.textV2.secondary}>
          {t('error.500.errorCode')}
        </Typography>
      }
      buttonTitle={t('error.500.button.title')}
      buttonAction={handleClick}
      backgroundImageUrl="/static/images/common/bg-500-server-error.png"
    />
  );
};

export default Component500;
